export const PRODUCT_VIEW_SET = 'PRODUCT_VIEW_SET';
export const PRODUCT_VIEW_LIST = 'PRODUCT_VIEW_LIST';
export const PRODUCT_AI_LIST = 'PRODUCT_AI_LIST';
export const PRODUCT_PREV_PAGE = 'PRODUCT_PREV_PAGE';